module.exports = __webpack_public_path__ + "img/registerPic.6fd3d2e8.png";